import { infoColor, infoBoxShadow } from '../global';

const surveyManagementStyle = {
    main: {
        padding: '23px',
    },
    fieldset: {
        borderColor: infoColor,
        borderRadius: '8px',
        ...infoBoxShadow,
        padding: '26px',
    },
    button: {
        display: 'flex',
        justifyContent: 'flex-end',
        padding: '23px',
    },
};

export default surveyManagementStyle;
